import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss']
})
export class UploadFilesComponent implements OnInit {

  @Input() maxFile: any;
  @Input() archivo!: string;
  @Input() selectedIndex: number = 0;

  @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedFiles: File[] = [];
  isLoading = false;

  @Output() dataEmitter: EventEmitter<any[]> = new EventEmitter<any[]>();

  constructor(
    private config: PrimeNGConfig,
    private messageService: MessageService
  ) {}

  ngOnInit() {}

  childFunction() {
    this.fileUpload.clear();
    this.uploadedFiles = [];
  }

  onFileSelect(event: any): void {
    if (!event || !event.files || event.files.length === 0) {
      console.warn("⚠️ No se seleccionó ningún archivo.");
      this.dataEmitter.emit([]);
      return;
    }

    this.uploadedFiles = this.fileUpload.files; // sincronizamos con la UI

    this.messageService.add({
      severity: 'info',
      summary: 'Archivo(s) seleccionado(s)',
      detail: this.uploadedFiles.map(f => f.name).join(', ')
    });

    if (this.selectedIndex === 1) {
      // ✅ Solo Planos Polca: convertir a base64
      this.convertToBase64(this.uploadedFiles);
    } else {
      // ✅ Otros tabs: emitir directamente File[]
      this.dataEmitter.emit(this.uploadedFiles);
    }
  }

  convertToBase64(files: File[]): void {
    const base64Files: any[] = [];
    let processedFiles = 0;

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        base64Files.push({
          file: file,
          base64: (reader.result as string).split(',')[1],
        });
        processedFiles++;
        if (processedFiles === files.length) {
          this.dataEmitter.emit(base64Files);
        }
      };
      reader.readAsDataURL(file);
    });
  }

  getIconClass(file: File): string {
    const fileName = file.name.toLowerCase();
    if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png')) {
      return 'pi pi-image';
    } else if (fileName.endsWith('.pdf')) {
      return 'pi pi-file-pdf';
    } else if (fileName.endsWith('.doc') || fileName.endsWith('.docx')) {
      return 'far fa-file-word';
    } else {
      return 'far fa-file';
    }
  }
}
